module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAjCAMAAAApB0NrAAAAPFBMVEUAAAD////////////////////////////////////////////////////////////////////////////YSWgTAAAAE3RSTlMAAgMEBUBUV1hbXWNkbG+yt7r9+nHL6AAAAHlJREFUOMvtlN0KgCAMRqc1TUsre/93zeyHRRohFQSdi+9iO4zvagAe44Y4zsBKSvHS5gxpnnE4aBqMRRwA3EfE0djTkPLv/PnOBdQ0OM/sXEJDI3rnrs4VtnQpRKozPZB5J8DmgTrrvAzwDUdhoDs6V/6PTf4xO61Hx107JCeAfkcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/asset/img/fa-building.png
// module id = 3301
// module chunks = 0